import React, { useEffect, useRef, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { mobile_app } from './data/mobile_app.json';
import APP from '../../utils/MobileAppWidget';
import { lobRoot, LobGetAppWidgetBg } from '../../utils/LobLogicModule';
import './MobileApp.scss';

import BankingTypeContext from '../../utils/BankingType/context';

const GetTheApp = () => {
	const { t, i18n } = useTranslation('mobile_app');
	const { bankingType } = useContext(BankingTypeContext);

	const DefaultGetApp = () => {
		const [isPhone, setPhone] = useState('');
		const getApp = useRef(null);

		const handleSelectDevice = e => {
			setPhone(e.target.value);
		}
	
		const focusNextInput = e => {
			(e.target.value.length > 2) && e.target.nextSibling.nextSibling.focus()
		}
	
		useEffect(() => {
			if (!getApp.current) return;
	
			APP.getapp.init(getApp.current);
		}, []);
		
		return (
			<div ref={getApp} className={`getapp container_wrapper get-app--wrapper ${bankingType}`} data-action="getapp">
				<div className="get-app--bground" aria-hidden="true">
					{<LobGetAppWidgetBg />}
				</div>

				<div className="get-app--content">
					<div className="download-app-content">
						<h2 className="getapp__description download-app-message" dangerouslySetInnerHTML={{ __html: t(mobile_app.copy) }}></h2>
						<span className="getapp__description download-app-message"><sup className="footnote"><a href="#footnote*" aria-label={t(mobile_app.footLabel)}>*</a></sup></span>
					</div>

					<div className="getapp__controls">
						<div className="getapp__group js-group-one getapp__group--visible">
							<p className="getapp__error getapp__error--hidden" tabIndex="0" dangerouslySetInnerHTML={{ __html: t(mobile_app.error.e1) }} />


							<div className="getapp__custom">
								<select data-bactmln="Widget-_-Click-_-DeviceDropdown" className="getapp__dropdown js-mobile-device t-track-deviceDropdown" aria-label={t(mobile_app.device.ariaLabel)} value={isPhone} onChange={handleSelectDevice}>
									<option value="defaultOption" lang={(i18n.language) + '-US'} dangerouslySetInnerHTML={{ __html: t(mobile_app.device.defaultValue) }} />
									<option value="iPhone" dangerouslySetInnerHTML={{ __html: t(mobile_app.device.iphone) }} />
									<option value="Android" dangerouslySetInnerHTML={{ __html: t(mobile_app.device.android) }} />
								</select>
							</div>

							<button id="GetTheApp" data-component="Widget" className="cta widget-cta cta--disabled t-track-custom" dangerouslySetInnerHTML={{ __html: t(mobile_app.getApp) }} data-bactmln="Widget-_-Click-_-GetTheApp" />
						</div>

						<div className="getapp__group js-group-two">
							<p className="getapp__message" dangerouslySetInnerHTML={{ __html: t(mobile_app.getMessage) }} />
							<p className="getapp__error getapp__error--hidden js-enter-tel" tabIndex="0" dangerouslySetInnerHTML={{ __html: t(mobile_app.error.e2) }} />
							
							<div className="getapp__telfields">
								<label className="ada-invisible" htmlFor="mobileAppPhone0" dangerouslySetInnerHTML={{ __html: t(mobile_app.telFields.telLabel1) }} />
								<input type="tel" className="tel js-tel-areacode mobileAppPhone0 mobileAppPhone" name="getMobileApp_phone0" size="3" maxLength="3" min="200" max="998" placeholder="XXX" autoComplete="off" aria-required="true" required onChange={focusNextInput} />

								<label className="ada-invisible" htmlFor="mobileAppPhone1" dangerouslySetInnerHTML={{ __html: t(mobile_app.telFields.telLabel2) }} />
								<input type="tel" className="tel js-tel-three mobileAppPhone1 mobileAppPhone" name="getMobileApp_phone1" size="3" maxLength="3" min="001" max="999" placeholder="XXX" autoComplete="off" aria-required="true" required onChange={focusNextInput} />

								<label className="ada-invisible" htmlFor="mobileAppPhone2" dangerouslySetInnerHTML={{ __html: t(mobile_app.telFields.telLabel3) }} />
								<input type="tel" className="tel tel--four js-tel-four mobileAppPhone2 mobileAppPhone" name="getMobileApp_phone2" size="4" maxLength="4" min="0001" max="9999" placeholder="XXXX" aria-required="true" required autoComplete="off" />

								<button id="Send" data-component="Widget" className="cta cta--disabled widget-cta getAppButton t-track-widget-cta t-track-custom" dangerouslySetInnerHTML={{ __html: t(mobile_app.btnSend) }} data-bactmln="Widget-_-Click-_-Send" />
							</div>
						</div>

						<div className="getapp__group getapp__group--confirmation js-group-confirmation" aria-live="assertive" aria-atomic="true" tabIndex="0">
							<div className="mobileApp_spinner"><div className="loading-spinner" role="status" aria-label="Processing"><div className="loading-anim"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div></div>

							<div className="getapp__success" hidden={true}>
								<p className="getapp__thankyou" dangerouslySetInnerHTML={{ __html: t(mobile_app.thankYou) }} />
								<p className="getapp__sentto" dangerouslySetInnerHTML={{ __html: t(mobile_app.messageSent) }} />
								<p className="getapp__phonenumber js-phonenumber" dangerouslySetInnerHTML={{ __html: t(mobile_app.telNumber) }} />
							</div>

							<div className="getapp__failure" tabIndex="0" hidden={true}>
								<p><strong dangerouslySetInnerHTML={{ __html: t(mobile_app.failureMsg) }} /></p>
								<p dangerouslySetInnerHTML={{ __html: t(mobile_app.somthingWrong) }} />
								<button id="TryAgain" data-component="Widget" className="cta cta--outline-white getAppTryAgain t-track-custom" dangerouslySetInnerHTML={{ __html: t(mobile_app.tryAgain) }} data-bactmln="Widget-_-Click-_-TryAgain" />
							</div>
						</div>
					</div>
					<div className="getapp__footer">
						<p className="getapp__disclaimer" dangerouslySetInnerHTML={{ __html: t(mobile_app.disclaimer) }} />
						{i18n.language === 'es' ? <a href="https://promotions.bankofamerica.com/consumer/es/messaging-terms-and-conditions" id="GetApp_TC" data-component="Widget" className="getapp__terms t-track-body-copy-link" target="_blank" rel="noopener noreferrer" data-bactmln="GetApp-_-Hyperlink-_-TermsAndConditions" dangerouslySetInnerHTML={{ __html: t(mobile_app.termsConditionText) }}/> : <a href="https://promotions.bankofamerica.com/consumer/messaging-terms-and-conditions" id="GetApp_TC" data-component="Widget" className="getapp__terms t-track-body-copy-link" target="_blank" rel="noopener noreferrer" data-bactmln="GetApp-_-Hyperlink-_-TermsAndConditions" dangerouslySetInnerHTML={{ __html: t(mobile_app.termsConditionText) }} />}
					</div>

					<div className="getapp__mobiledownload">
						{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
						<a href="#" id="DownloadTheApp" data-component="Widget" className="cta cta--disabled cta--dynamic t-track-cta" data-bactmln="Widget-_-CTA-_-DownloadTheApp" dangerouslySetInnerHTML={{ __html: t(mobile_app.downloadApp) }} />
					</div>
				</div>
			</div>
		)
	};

	const MobileGetApp = ({ appleLink, googleLink, websiteLink }) => (
		<div className={`getapp mobile-get-app__wrapper ${bankingType}`}>
			<div className="mobile-get-app__content">
				<div className="mobile-get-app__message-container">
					<h2 className="mobile-get-app__message" dangerouslySetInnerHTML={{ __html: t(mobile_app.copyMobile) }}></h2>
				</div>

				<div className="mobile-get-app__column">
					<div className="mobile-get-app__column-message-container">
						<h3 className="mobile-get-app__column-message" dangerouslySetInnerHTML={{ __html: t(mobile_app.mobileLabel) }}></h3>
					</div>

					<div className="mobile-get-app__button-container">
						<a
							className="mobile-get-app__button-link t-track-cta"
							target="_blank"
							data-component="Widget"
							data-bactmln="Widget-_-CTA-_-AppStore_DownloadApp"
							rel="noreferrer noopener"
							href={appleLink}
						>
							<picture className="mobile-get-app__button-picture">
								<source media="(max-width: 419px)" srcSet={`${process.env.PUBLIC_URL}` + t(mobile_app.appButtons.mobile.apple)} />
								<source media="(min-width: 420px)" srcSet={`${process.env.PUBLIC_URL}` + t(mobile_app.appButtons.desktop.apple)} />
								<img src={`${process.env.PUBLIC_URL}` + t(mobile_app.appButtons.desktop.apple)} alt={`${t(mobile_app.appButtons.label.apple)}`} />
							</picture>
						</a>
					</div>

					<div className="mobile-get-app__button-container">
						<a
							className="mobile-get-app__button-link t-track-cta"
							target="_blank"
							data-component="Widget"
							data-bactmln="Widget-_-CTA-_-PlayStore_DownloadApp"
							rel="noreferrer noopener"
							href={googleLink}
						>
							<picture className="mobile-get-app__button-picture">
								<source media="(max-width: 419px)" srcSet={`${process.env.PUBLIC_URL}` + t(mobile_app.appButtons.mobile.google)} />
								<source media="(min-width: 420px)" srcSet={`${process.env.PUBLIC_URL}` + t(mobile_app.appButtons.desktop.google)} />
								<img src={`${process.env.PUBLIC_URL}` + t(mobile_app.appButtons.desktop.google)} alt={`${t(mobile_app.appButtons.label.google)}`} />
							</picture>
						</a>
					</div>
				</div>

				<div className="mobile-get-app__column">
					<div className="mobile-get-app__column-message-container">
						<h3 className="mobile-get-app__column-message" dangerouslySetInnerHTML={{ __html: t(mobile_app.websiteLabel) }}></h3>
					</div>
					<div className="mobile-get-app__button-container">
						<a
							className="mobile-get-app__cta t-track-cta"
							data-component="Widget"
							data-bactmln="Widget-_-CTA-_-EnrollNow_DownloadApp"
							target="_blank"
							rel="noreferrer noopener"
							href={websiteLink}
							dangerouslySetInnerHTML={{ __html: t(mobile_app.appButtons.label.website)}}
						/>
					</div>
				</div>
			</div>
		</div>
	);

	switch (lobRoot) {
		case '/ml':
			return <MobileGetApp 
				appleLink={t(mobile_app.appButtons.link.apple.ml)}
				googleLink={t(mobile_app.appButtons.link.google.ml)}
				websiteLink={t(mobile_app.appButtons.link.website.ml)}
			/>;
		case '/privatebank':
			return <MobileGetApp 
				appleLink={t(mobile_app.appButtons.link.apple.pb)}
				googleLink={t(mobile_app.appButtons.link.google.pb)}
				websiteLink={t(mobile_app.appButtons.link.website.pb)}
			/>;
		default:
			return <DefaultGetApp />;
	}
}

export default GetTheApp;